export enum WidgetLayoutType {
    Default = 1,
    SingleTileLayout = 2,
}